/**
 * bootprompt.js locale configuration
 * locale : Danish
 * author : Frederik Alkærsig
 */

import { addLocale } from "../bootprompt";

addLocale("da", {
  OK: "OK",
  CANCEL: "Annuller",
  CONFIRM: "Accepter",
});
